import { Provider as ReduxProvider } from 'react-redux'
import { StylesProvider } from '@mui/styles'
import { HelmetProvider, Helmet } from 'react-helmet-async'
import { create } from 'jss'
import jssPreset from '@mui/styles/jssPreset'
import { useRoutes } from 'react-router-dom'
import './i18n'
import routes from './routes/index'
import { AuthProvider as CognitoAuthProvider } from './contexts/CognitoContext'
import { AuthProvider as JwtAuthProvider } from './contexts/JWTContext'
// import { PersistGate } from 'redux-persist/integration/react'
// import { persistStore } from 'redux-persist'

// const persistor = persistStore(store)
import store from './redux'
import useHotjar from './hooks/useHotjar'
import { LanguageProvider } from './contexts/LanguageContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { PolicyProvider } from './contexts/PolicyContext'
import { UpdateCheck } from './components/UpdateCheck'
import { SettingsProvider } from './contexts/SettingsContext'
import { AIAgentProvider } from './contexts/AIAgentContext'

const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById('jss-insertion-point') ?? undefined
})

export default function App() {
  /**
   * The route component.
   */
  const route = useRoutes(routes)

  useHotjar()

  const AuthProvider =
    import.meta.env?.VITE_APP_AUTH_PROVIDER === 'cognito' ? CognitoAuthProvider : JwtAuthProvider

  return (
    <HelmetProvider>
      <Helmet titleTemplate="%s | Spine" defaultTitle="Spine - Dashboard" />
      <ReduxProvider store={store}>
        <StylesProvider jss={jss}>
          <LanguageProvider>
            <ThemeProvider>
              <SettingsProvider>
                <AuthProvider>
                  <UpdateCheck />
                  <AIAgentProvider>
                    <PolicyProvider>{route}</PolicyProvider>
                  </AIAgentProvider>
                </AuthProvider>
              </SettingsProvider>
            </ThemeProvider>
          </LanguageProvider>
        </StylesProvider>
      </ReduxProvider>
    </HelmetProvider>
  )
}
